import _ from 'lodash';
import moment from 'moment';

import { ANSWERS, MODES, EVENTS, JANUARY_INDEX, DECEMBER_INDEX } from 'common/domain/constants';
import tooltip from 'common/utils/tooltip';
import { Request } from 'common/domain/models/request';
import RequestHelper from './requestFormHelper';
import {
  PATERNITY_CODE, MATERNITY_CODE, VA_SWITCH_CONFIG, SINDICAL_REPRESENTATION_HOURS_CODE, MAX_HOURS, PATERNITY_SECOND_PERIOD_CODE,
  MATERNITY_SECOND_PERIOD_CODE,
} from 'vacations-absences.module/common/domain/constants';

class RequestFormController {
  constructor(
    $scope,
    $rootScope,
    $state,
    $log,
    $timeout,
    $location,
    EventEmitter,
    requestFormService,
    vacationUserDataService,
    ManagerDataService,
    loadingMobileService,
    floatingActionButtonsService,
    metricsService
  ) {
    'ngInject';
    this.log = $log;
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.state = $state;
    this.location = $location;
    this.timeout = $timeout;
    this.EventEmitter = EventEmitter;

    this.tooltip = tooltip;
    this.requestFormService = requestFormService;
    this.UserDataService = vacationUserDataService;
    this.ManagerDataService = ManagerDataService;
    this.floatingActionButtonsService = floatingActionButtonsService;
    this.loadingMobileService = loadingMobileService;
    this.metricsService = metricsService;
    this.success = undefined;
    this.error = undefined;
    this.errors = [];
    this.sickLeaveReports = [];
    this.ongoing = false;
    this.relapsesOcurrences = 3;
    this.isSubmitted = false;
    this.numberWithPrecisionTwo = /^[0-9]+(\.[0-9]{1,2})?$/;
    this.absenceMinHours = 0.1;
    this.absenceMaxHours = 9.75;
    this.initVisibilityFunctions();
    this.switchOptions = VA_SWITCH_CONFIG;
  }

  $postLink() {
    this.checkMedicalPartsAdded();
  }

  $onInit() {
    this.openTooltipNestedModals = true;
    this.managerAsEmployeeData = this.getUserRequestFromManagerData();
    this.initialRequestType = undefined;
    this.initialRequestCategory = undefined;
    this.requestTypes = this.getRequestTypes();
    this.requestCategories = [];
    this.endDate = null;
    this.initStartDate = null;
    this.startDate2Period = null;
    this.endDate2Period = null;
    this.initEndDate = this.startDate;
    this.sicknessLeaveDate = null;
    this.isDisabledSickLeaveReports = false;
    this.continuousPatenity = true;
    this.continuousOldPatenity = false;
    this.dayClicked = this.startDate;
    this.birthDateChild = null;

    this.setVacationsMinDateOnNewYear();
    this.setAbsencesMinDateOnNewYear();

    if (this.isMobileApp) {
      this.floatingActionButtons = this.getFloatingActionButtons();
      this.setFloatingActionButtonsDisabled();
    }

    if (RequestHelper.isAbsenceRequest(this.type)) {
      this.getRelapses();
      this.sicknessLeaveDateKnownReasons = RequestHelper.getLeaveSicknessReasons(this.UserDataService);
    }

    if (!this.isEdit()) {
      return;
    }

    // Prefill form and other stuff if we are on inception

    const type = this.getRequestTypeFromPeriod(this.periodToEdit);
    this.setTypeAndRequestTypes(type);

    this.initialRequestType = RequestHelper.findRequestTypeByCode(this.requestTypes, this.periodToEdit.code);

    if (!this.initialRequestType) {
      this.log.warn('requestForm.controller: editing but initialRequestType empty...');
    }

    this.initialRequestCategory = RequestHelper.findRequestCategoryByCode(this.requestCategories, this.periodToEdit.code);

    if (!this.initialRequestCategory) {
      this.log.warn('requestForm.controller: editing but initialRequestCategory empty...');
    }

    this.initialRequestTypeBackup = _.cloneDeep(this.initialRequestType);
    this.initialRequestCategoryBackup = _.cloneDeep(this.initialRequestCategory);

    this.leaveSicknessReasons = RequestHelper.getLeaveSicknessReasons(this.UserDataService);

    if (this.originalPeriod.sickLeaveReport) {
      this.sickLeaveReports = RequestHelper.mapSickLeaveReports(this.originalPeriod.sickLeaveReport);
      this.sickLeaveReports.sort((a, b) => new Date(a.date) > new Date(b.date));
    }

    if (this.initialRequestCategory) {
      this.avoidEmptyCodeOnEdit();
    }

    this.forceShowAbsenceFlowWhenVacationEditOnInception();
    this.setAbsenceHours();
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.SUBMIT',
        disabled: true
      }, {
        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
      }
    ];
  }

  isInputFocused() {
    return this.floatingActionButtonsService.isFocused;
  }

  getInputDateSicknessClass() {
    return {
      'col-xs-5': !this.isMobileApp,
      'col-xs-6': this.isMobileApp
    };
  }

  getInputCollegiateNumberClass() {
    return {
      'col-xs-7': !this.isMobileApp,
      'col-xs-6': this.isMobileApp
    };
  }

  getRelapseCheckClass() {
    return {
      'col-xs-6': !this.isMobileApp,
      'col-xs-12': this.isMobileApp
    };
  }

  setFloatingActionButtonsDisabled() {
    this.scope.$watch(() => this.form.$invalid, newValue => {
      if (newValue || this.isDisabledSickLeaveReports || this.isBirthDateChildMissing()) {
        this.floatingActionButtons[0].disabled = true;
      }
      else {
        this.floatingActionButtons[0].disabled = false;
      }
    });
  }

  setTypeAndRequestTypes(type) {
    this.type = type;
    this.requestTypes = [];
    this.requestTypes = this.getRequestTypes();
    this.requestCategories = RequestHelper.getRequestCategoriesByCode(this.requestTypes, this.periodToEdit.code);
  }

  initVisibilityFunctions() {
    this.isCreate = () => {
      return this.mode === MODES.CREATE;
    };

    this.isEdit = () => {
      return this.mode === MODES.EDIT;
    };

    this.isSickness = () => {
      return this.isSicknessRequest;
    };

    this.isCreateSickness = () => {
      return this.isCreate() && this.isSicknessRequest;
    };

    this.isEditSickness = () => {
      return this.isEdit() && this.isSicknessRequest;
    };

    this.isSicknessEditOnCancel = () => {
      return this.isEditSickness() && this.sicknessLeaveAnswer === ANSWERS.NO;
    };

    this.isSicknessEditOnContinue = () => {
      return this.isEditSickness() && this.sicknessLeaveAnswer === ANSWERS.YES;
    };

    this.isVacation = () => {
      return RequestHelper.isVacationRequest(this.type);
    };

    this.isAbsence = () => {
      return RequestHelper.isAbsenceRequest(this.type);
    };
  }

  resetBackup() {
    this.resetForm();
  }

  submit() {
    const request = this.getRequest(this.isSicknessRequest, this.originalPeriod);
    this.isSubmitted = true;

    let data;

    const onError = (response) => {
      this.onError(this.EventEmitter(response));
    };

    const onSuccess = () => {
      if (this.isMobileApp && this.isInception()) {
        this.metricsService.trackVacationsAbsencesCreateAbsenceFromManagerToEmployee();
      }
      this.addEvent(this.EventEmitter(request));
      this.ongoing = false;
      this.onSuccess();
    };

    this.ongoing = true;

    const isEditingANonSick = this.isEdit() && !this.isSicknessEditOnCancel() && !this.isSicknessEditOnContinue();
    const isAbsenceInVacation = this.isEdit() && (request.type !== this.originalPeriod.type);

    this.loadingMobileService.show();
    const userId = this.userInceptionId || this.getUserId();
    const managerId = this.UserDataService._employee.userId;

    if (isEditingANonSick && !isAbsenceInVacation) {
      data = RequestHelper.getRequestOnUpdate(request, this.originalPeriod);
      this.requestFormService.update(userId, data, this.isInception(), managerId)
        .then(onSuccess, onError)
        .finally(() => this.loadingMobileService.hide());

    } else if (this.isSicknessEditOnCancel()) {
      data = RequestHelper.getRequestOnUpdateSicknessOnCancel(request, this.originalPeriod);
      this.requestFormService.updateSicknessWhenNo(userId, data, this.isInception(), managerId).then(onSuccess, onError).finally(() => this.loadingMobileService.hide());

    } else if (this.isSicknessEditOnContinue()) {
      data = RequestHelper.getSickLeaveReportsOnCreate(this.sickLeaveReports, this.originalPeriod);
      this.requestFormService.createSickLeaveReports(userId, data, this.isInception(), managerId).then(onSuccess, onError).finally(() => this.loadingMobileService.hide());

    } else {
      data = RequestHelper.getRequestOnCreate(request);
      this.requestFormService.create(userId, data, this.isInception(), managerId)
        .then(onSuccess, onError)
        .finally(() => this.loadingMobileService.hide());
    }

    this.ongoing = false;
  }

  _getRequestStartDate(originalPeriod) {
    if (this.isCreateSickness()) {
      return this.startDate;
    }
    return this.startDate || new Date(originalPeriod.startDate);
  }

  getRequest(isSicknessRequest, originalPeriod) {
    let requestStartDate = this._getRequestStartDate(originalPeriod);

    let request = {
      endDate: this.endDate,
      startDate: requestStartDate,
      code: this.selectedRequestCode,
      codeCategory: this.selectedRequestCode,
      type: this.type,
    };

    if (!this.continuousPatenity && this.isPaternity5Week()) {
      request.endDateFifthWeek = this.endDate2Period;
      request.startDateFifthWeek = this.startDate2Period;
    }

    if (isSicknessRequest) {
      delete request.endDate;
      request.collegiateNumber = this.collegiateNumber || '';
      if (this.isRelapse) {
        request.relapseDate = this.relapseDate;
      }

      if (this.isLeaveDateSelected || this.isEditSickness()) {
        request.endDate = this.sicknessLeaveDate;
      }

      if (this.sicknessLeaveDateKnownReason) {
        request.sicknessLeaveDateKnownReason = this.sicknessLeaveDateKnownReason;
      }

      if (this.leaveSicknessReason) {
        request.leaveSicknessReason = this.leaveSicknessReason;
      }

      if (this.isCreateSickness()) {
        request.startDate = this.sicknessStartDate;
      }
    }

    if (this.isHourlyRequest) {
      request.hours = this.absenceHours;
    }

    if (this.birthDateChild) {
      request.birthDateChild = this.birthDateChild;
    }
    return request;
  }

  getUserRequestFromManagerData() {
    if (!this.isInception()) {
      return;
    }

    return this.ManagerDataService.getManager().listRequestsEmployees.find((user) => {
      return user.employeeId === this.userInceptionId;
    });
  }

  isInception() {
    return this.state.current.component !== 'myVacations' && this.state.current.component !== 'myVacationsMobile' && this.state.current.component !== 'periodListMobile';
  }

  filterRelapsesBeforeStartDate() {
    return this.relapses.filter((relapseObject) => {
      let dateFormatted = new Date(relapseObject.value);
      return dateFormatted <= this.sicknessStartDate;
    });
  }

  getRelapses() {
    this.loadingMobileService.show();
    const userId = this.userInceptionId || this.getUserId();
    const managerId = this.UserDataService._employee.userId;
    const isInception = this.isInception();

    this.requestFormService.getRelapses(userId, isInception, managerId)
      .then(({ data }) => {
        this.relapses = RequestHelper.sanitizeRelapses(data.relapsesPeriods);
        if (this.sicknessStartDate)
          this.relapses = this.filterRelapsesBeforeStartDate();
      })
      .catch(() => {
        this.relapsesError = true;
      })
      .finally(() => this.loadingMobileService.hide());
  }

  shouldRenderRelapseCheckbox() {
    return this.isCreateSickness() && this.relapses.length !== 0;
  }

  getCurrentSessionUserID() {
    return this.UserDataService.getEmployee().userId;
  }

  getRequestTypes() {
    let typesToReturn = [];
    if (this.isInception()) {
      typesToReturn = RequestHelper.getRequestTypesManager(this.managerAsEmployeeData);
    } else {
      typesToReturn = RequestHelper.getRequestTypes(this.UserDataService, this.type);
    }
    return typesToReturn;
  }

  getUserId() {
    return this.userId;
  }

  /**
   * When we switch the type of a request, we must recharge the types and categories, and also
   * restore the vacation selection when we return from absence to vacation. Also, when is an
   * absence, set the mode to create, for avoid collision when edit-sickness flow.
   */
  switchRequestTypes($event) {
    this.timeout(() => {
      this.restartRequestSelects = true;
      this.showSwitchRequestTypes = true;
      this.mode = MODES.CREATE; // Avoid show sick extra elements because previous mode was edit
      this.scope.$apply(); // Force select component repaint
      this.newRequestType = $event.option;
      this.log.info('Switch request type, new request type is ...', this.newRequestType);
      this.setTypeAndRequestTypes(this.newRequestType);
      this.initialRequestType = null;
      this.initialRequestCategory = null;
      this.isSicknessRequest = false;

      if (this.newRequestType === Request.TYPES.VACATION) {
        this.initialRequestType = this.initialRequestTypeBackup;
        this.initialRequestCategory = this.initialRequestCategoryBackup;
        this.restoredInitialRequestValues = true;
        this.mode = MODES.EDIT;
      } else {
        this.restoredInitialRequestValues = false;
        this.mode = MODES.CREATE;
      }

      this.scope.$apply(); // Force select component repaint
      this.restartRequestSelects = false;
    });
  }

  avoidEmptyCodeOnEdit() {
    this.onSelectRequestCategory({ $item: this.initialRequestCategory });
  }

  getRequestTypeFromPeriod(period) {
    return period.type;
  }

  isInvalid(form) {
    return RequestHelper.formIsInvalid(form) && this.isSubmitted;
  }

  onSelectRequestType({ $item }) {
    this.requestCategories = [];
    this.selectedRequestCode = null;
    this.form.requestCategories.$setPristine(); // Avoid show error on second select on clean code
    this.scope.$apply();
    this.requestCategories = $item.value.map(RequestHelper.mapRequestCategory);
  }

  /**
   * This function determines if the request type select must be disabled.
   * The request type select must be disabled when:
   *   - We do not have request types
   *   - We are editing
   *   - The request switch has not been touched
   *   - The initial request types has been restored (this means, insert absence in a vacation period
   *     but clicked again vacation)
   *
   * @returns {boolean} - Request type select must be disabled.
   */
  disableRequestTypesSelector() {
    const noRequestTypes = !this.requestTypes;
    const isEdit = this.isEdit();
    const requestSwitchPristine = !this.newRequestType;
    return ((noRequestTypes || isEdit) && requestSwitchPristine) || this.restoredInitialRequestValues;
  }

  onSelectRequestCategory({ $item }) {
    this.selectedRequestCode = $item.value;
    this.emitData(this.EventEmitter($item));
    this.absenceMaxHours = this.selectedRequestCode === SINDICAL_REPRESENTATION_HOURS_CODE ? MAX_HOURS.SINDICAL_REPRESENTATION : MAX_HOURS.GENERAL_HOURLY_ABSENCES;
    if (!this.selectedRequestCode) {
      this.log.warn('requestForm.controller: Cannot discern if period is sickness, no given code');
    }

    this.isDisplacementRequest = RequestHelper.isDisplacement(this.selectedRequestCode);
    this.isSicknessRequest = RequestHelper.periodIsSickness(this.selectedRequestCode);
    this.isHourlyRequest = RequestHelper.isHourly(this.requestCategories, this.selectedRequestCode);
    if (this.isHourlyRequest) {
      this.absenceMaxHours = RequestHelper.getHourlyMax(this.requestCategories, this.selectedRequestCode);
    }

    if (RequestHelper.isAbsenceRequest(this.type)) {
      this.setMaximumDurationWhenPaternityOrMaternity(this.selectedRequestCode);
    }
    this.timeout(() => {
      this.floatingActionButtonsService.run();
    });
  }

  setMaximumDurationWhenPaternityOrMaternity(selectedRequestCode) {
    /*  let duration;
     let maximumDuration = RequestHelper.getMaximumDurationPaternityAndMaternity(requestTypes); */
    let maximumDurationMatPat = RequestHelper.getMaximumDurationMATPAT(this.startDate, selectedRequestCode, this.UserDataService.getMatPatPeriods());

    let isMaternityOrPaternity = this.checkMaternity(selectedRequestCode) || this.checkPaternity(selectedRequestCode);
    if (isMaternityOrPaternity) {
      /*     duration = this.checkMaternity(selectedRequestCode) ? maximumDuration.maternity : maximumDuration.paternity; */
      this.endDate = moment(this.startDate).add(maximumDurationMatPat - 1, 'days').toDate();
    }
  }

  checkMaternity(selectedRequestCode) {
    return selectedRequestCode === MATERNITY_CODE;
  }

  checkPaternity(selectedRequestCode) {
    return selectedRequestCode === PATERNITY_CODE;
  }

  /**
   * This function determines if the request category select must be disabled.
   * The request category select must be disabled when:
   *   - We do not have request categories. But in this case by lenght.
   *   - We are editing.
   *   - The request switch has been not touched.
   *   - The initial request types has been restored (this means, insert absence in a vacation period
   *     but clicked again vacation).
   *
   * @returns {boolean} - Request category select must be disabled.
   */
  disableRequestCategoriesSelector() {
    const noRequestCategories = this.requestCategories.length === 0;
    const isEdit = this.isEdit();
    const requestSwitchPristine = !this.newRequestType;
    return ((noRequestCategories || isEdit) && requestSwitchPristine) || this.restoredInitialRequestValues;
  }

  datepickInitDate({ date }) {
    this.startDate = date;

    if (!this.form.endDate) {
      return;
    }

    this.setMaximumDurationWhenPaternityOrMaternity(this.selectedRequestCode);
    if (this.isMobileApp) {
      this.setMinEndDateToMobile(this.startDate);
    }

    if (this.endDate && (this.startDate > this.endDate)) {
      this.form.startDate.$setValidity('validRange', false);
    } else {
      this.setValidRange();
    }
  }

  datepickInitDate2Period({ date }) {
    this.startDate2Period = date;
    if (!this.form.endDate2Period) {
      return;
    }

    if (this.isMobileApp) {
      this.setMinEndDateToMobile(this.startDate);
    }

    if (this.endDate2Period && (this.startDate2Period > this.endDate2Period)) {
      this.form.startDate.$setValidity('validRange2Period', false);
    } else {
      this.setValidRange();
    }
  }

  datepickEndDate({ date }) {
    this.endDate = date;
    if (this.startDate && (this.endDate < this.startDate)) {
      this.form.endDate.$setValidity('validRange', false);
    } else {
      this.setValidRange();
    }
  }

  datepickEndDate2Period({ date }) {
    this.endDate2Period = date;
    if (this.startDate2Period === null) {
      return;
    }

    if (this.startDate2Period && (this.endDate2Period < this.startDate2Period)) {
      this.form.endDate2Period.$setValidity('validRange2Period', false);
    } else {
      this.setValidRange();
    }
  }

  isBirthDateChildRequired() {
    return this.selectedRequestCode === PATERNITY_SECOND_PERIOD_CODE || this.selectedRequestCode === MATERNITY_SECOND_PERIOD_CODE;
  }

  isBirthDateChildMissing() {
    return this.isBirthDateChildRequired() && !this.birthDateChild;
  }

  onChangePaternityConinuos() {
    this.setMaximumDurationWhenPaternityOrMaternity(this.selectedRequestCode);
  }

  datepickLeaveDateKnown({ date }) {
    this.sicknessLeaveDate = date;
    this.checkSicknessLeaveValidity();
  }

  setMinInitialDateToMobile(minDate) {
    this.minInitialDate = minDate;
  }

  setMinEndDateToMobile(startDate) {
    this.minEndDate = startDate;
  }

  setLeaveDateSendStatus({ selected }) {
    this.isLeaveDateSelected = selected;
  }

  checkSicknessLeaveValidity() {
    if (!this.isCreateSickness()) return;
    if (this.sicknessStartDate && this.sicknessLeaveDate && (this.sicknessLeaveDate < this.sicknessStartDate)) {
      this.form.sicknessLeaveDate.$setValidity('validRange', false);
    } else {
      this.setValidRangeLeaveDateKnown();
    }
  }

  datepickSicknessStartDate($event) {
    this.sicknessStartDate = $event.date;
    if (this.isMobileApp) {
      this.setMinEndDateToMobile(this.sicknessStartDate);
    }
    this.checkSicknessLeaveValidity();
    this.getRelapses();
  }

  datepickSicknessLeaveDate($event) {
    this.sicknessLeaveDate = $event.date;
  }

  setValidRangeLeaveDateKnown() {
    if (!this.sicknessStartDate) {
      this.initStartDate = angular.copy(this.sicknessLeaveDate);
    }

    if (!this.sicknessLeaveDate) {
      this.initLeaveDateKnown = angular.copy(this.sicknessStartDate);
    }

    this.form.sicknessLeaveDate.$setValidity('validRange', true);
    this.form.sicknessStartDate.$setValidity('validRange', true);
  }

  setValidRange() {
    if (!this.startDate) {
      this.initStartDate = angular.copy(this.endDate);
    }

    if (!this.endDate) {
      this.initEndDate = angular.copy(this.startDate);
    }

    this.form.endDate.$setValidity('validRange', true);
    this.form.startDate.$setValidity('validRange', true);
    if (!this.continuousOldPatenity && !this.continuousPatenity && this.isAbsence() && this.isPaternity5Week()) {
      this.form.endDate2Period.$setValidity('validRange2Period', true);
      this.form.startDate2Period.$setValidity('validRange2Period', true);
    }
  }

  isPaternity5Week() {
    return this.selectedRequestCode == PATERNITY_CODE;
  }
  onSelectRelapse($event) {
    this.relapseDate = $event.$item.value;
  }

  openSicknessPanel() {
    this.sicknessPanelOpened = !this.sicknessPanelOpened;
  }

  sicknessPanelIsOpen() {
    return this.sicknessPanelOpened;
  }

  onSelectLeaveSicknessReason($event) {
    this.leaveSicknessReasonInitialValue = $event.$item;
    this.leaveSicknessReason = $event.$item.value;
  }

  selectSicknessLeaveDateKnownReason($event) {
    this.sicknessLeaveDateKnownReason = $event.value;
  }

  requestTypeSwitchVisible() {
    const isEditingANonSick = this.isEdit() && !this.isEditSickness();
    const locked = !!this.lockOn;
    return isEditingANonSick || locked || this.showSwitchRequestTypes;
  }

  requestTypeSwitchEditable() {
    if (!this.periodToEdit) {
      return false;
    }

    return RequestHelper.requestTypeSwitchEditable(this.periodToEdit, this.isInception());
  }

  /**
   * When we are on inception, and edit a vacation, only allow to insert absence, not modify the
   * vacation request.
   */
  forceShowAbsenceFlowWhenVacationEditOnInception() {
    if (this.isInception() && RequestHelper.isVacationRequest(this.originalPeriod.type)) {
      this.type = Request.TYPES.ABSENCE;
      this.switchRequestTypes({ requestType: Request.TYPES.ABSENCE });
    }
  }

  setAbsenceHours() {
    if (!Request.isHourly(this.periodToEdit)) {
      return;
    }

    this.absenceHours = parseFloat(this.periodToEdit.hours);
  }

  cancel() {
    return this.onDismiss();
  }

  showFormSickLeaveReports() {
    return this.isSicknessEditOnContinue() && !this.sicknessPanelIsOpen();
  }

  submitButtonIsDisabled() {
    return this.form.$invalid === true || this.ongoing || this.isDisabledSickLeaveReports || this.isBirthDateChildMissing();
  }

  checkMedicalPartsAdded() {
    if (this.showFormSickLeaveReports()) {
      this.isDisabledSickLeaveReports = true;
      this.rootScope.$on(EVENTS.BUTTON_SICK_LEAVE_REPORTS_DISABLED, () => {
        this.isDisabledSickLeaveReports = false;
      });
    }
  }

  setVacationsMinDateOnNewYear() {
    const isRequestingVacationsInMobile = this.isMobileApp && this.type === Request.TYPES.VACATION;

    if (isRequestingVacationsInMobile) {
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth();
      this.setMinInitialDateToMobile(new Date(currentYear, currentMonth, 1));
    }

  }

  setAbsencesMinDateOnNewYear() {
    const isRequestingAbsencesInMobile = this.isMobileApp && this.type === Request.TYPES.ABSENCE;
    const isActuallyJanuary = new Date().getMonth() === JANUARY_INDEX;

    if (isRequestingAbsencesInMobile && isActuallyJanuary) {
      const currentYear = new Date().getFullYear();
      this.setMinInitialDateToMobile(new Date(currentYear - 1, DECEMBER_INDEX, 1));
    } else if (isRequestingAbsencesInMobile && !isActuallyJanuary) {
      const currentYear = new Date().getFullYear();
      this.setMinInitialDateToMobile(new Date(currentYear, JANUARY_INDEX, 1));
    }

  }

  onBirthDateChildInputChange() {
    const input = this.birthDateChildInput || '';
    const digits = input.replace(/\D/g, '').slice(0, 8);
  
    let formatted = digits;
    if (digits.length > 4) {
      formatted = digits.slice(0, 2) + '/' + digits.slice(2, 4) + '/' + digits.slice(4);
    } else if (digits.length > 2) {
      formatted = digits.slice(0, 2) + '/' + digits.slice(2);
    }
  
    this.birthDateChildInput = formatted;
    this.birthDateChild = null;
    this.form.birthDateChild.$setValidity('invalidYear', true);
  
    const match = formatted.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (match) {
      const [, day, month, year] = match;
      const currentYear = new Date().getFullYear();
      const parsedYear = parseInt(year, 10);
  
      if (parsedYear > currentYear || parsedYear < 1900) {
        this.form.birthDateChild.$setValidity('invalidYear', false);
        return;
      }
  
      this.birthDateChild = `${year}-${month}-${day}`;
    }
  }
}

export default RequestFormController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/requestForm/requestForm.controller.js